import { EditorBindingType, PropertyEditorType } from '../../model/enumerations';
import template from './mx-control-property-editor.html';

angular.module('mx.SolutionBuilderAgent').component('mxControlPropertyEditor', {
	bindings: {
		value: '=?',
		properties: '<value2',
		label: '@',
		disabled: '=ngDisabled',
	},
	controller: MxControlPropertyEditorCtrl,
	controllerAs: 'vm',
	template,
});

MxControlPropertyEditorCtrl.$inject = ['$scope', 'mx.SolutionBuilderAgent.StylesService'];

function MxControlPropertyEditorCtrl($scope, stylesService) {
	const vm = this;
	let tags;
	let supportedTypes = [{ Type: 1 }];
	let enumeration = '';
	let localChanged = false;
	let type = 0;

	loadStyles().then((tags) => (vm.tags = tags));

	vm.$onInit = function () {
		vm.mode = 1;
		vm.entityClassName = '';
		vm.allowedTypes = '';
		vm.useObjectId = false;
		vm.useMultiSelect = false;
		vm.supportedTypes = {};
		vm.enumeration = {};
		vm.editorTypes = [];
		vm.enumerationUpdate = strEnumerationToJson;

		stFromArray();
		strEnumerationFromJson();
		localChanged = false;

		vm.editors = [
			{
				name: 'ControlPropertyEditor',
				title: 'Property Editor',
				value: 0,
				editorTypes: [
					{ name: 'String', value: PropertyEditorType.String },
					{ name: 'Boolean', value: PropertyEditorType.Boolean },
					{ name: 'Integer', value: PropertyEditorType.Integer },
					{ name: 'Localizable', value: PropertyEditorType.Localizable },
					{ name: 'Image', value: PropertyEditorType.Image },
					{ name: 'Unit', value: PropertyEditorType.Unit },
					{ name: 'Complex Data', value: PropertyEditorType.ComplexData },
					{ name: 'Text', value: PropertyEditorType.Text },
					{ name: 'Layout Grid', value: PropertyEditorType.LayoutGrid },
				],
			},
			{
				name: 'ControlBindablePropertyEditor',
				title: 'Bindable Editor',
				value: 1,
				supportedKey: 'SupportedTypes',
				editorTypes: [{ name: 'Bindable', value: PropertyEditorType.Bindable }],
			},
			{
				name: 'ControlEnumerationPropertyEditor',
				title: 'Enumeration Editor',
				value: 3,
				supportedKey: 'Enumeration',
				editorTypes: [{ name: 'Enumeration', value: PropertyEditorType.Enumeration }],
			},
			{
				name: 'ControlStylePropertyEditor',
				title: 'Style Editor',
				value: 4,
				supportedKey: 'RelatedTag',
				editorTypes: [{ name: 'Style Picker', value: PropertyEditorType.StylePicker }],
			},
			{
				name: 'ControlSchemaPropertyEditor',
				title: 'Schema Editor',
				value: 5,
				supportedKey: ['Mode', 'Bindable', 'IsMultiPicker'],
				editorTypes: [{ name: 'Schema', value: PropertyEditorType.Schema }],
			},
			{
				name: 'ControlObjectPickerPropertyEditor',
				title: 'Object Picker Editor',
				value: 6,
				supportedKey: ['EntityClassName', 'AllowedTypes', 'UseObjectId', 'UseMultiSelect'],
				editorTypes: [{ name: 'Object Picker', value: PropertyEditorType.ObjectPicker }],
			},
			{
				name: 'ControlDescriptorStylesPropertyEditor',
				title: 'Descriptor Style Editor',
				value: 7,
				editorTypes: [{ name: 'Descriptor Styles Picker', value: PropertyEditorType.DescriptorStylesPicker }],
			},
			{
				name: 'ControlFilterExpressionPropertyEditor',
				title: 'Filter Expression Editor',
				value: 8,
				supportedKey: ['DataDefinitionPropertyName'],
				editorTypes: [{ name: 'Filter Expression Editor', value: PropertyEditorType.ExpressionFilter }],
			},
		];

		vm.editors.getByValue = function (value) {
			return _.find(vm.editors, ['value', value]) || {};
		};

		vm.types = [
			{ name: 'GuidType', value: 0 },
			{ name: 'StringType', value: 1 },
			{ name: 'BoolType', value: 2 },
			{ name: 'DateType', value: 3 },
			{ name: 'IntType', value: 4 },
			{ name: 'FloatType', value: 5 },
			{ name: 'DecimalType', value: 6 },
			{ name: 'TextType', value: 7 },
			{ name: 'ObjectReference', value: 8 },
			{ name: 'EnumReference', value: 9 },
			{ name: 'Fragment', value: 10 },
			{ name: 'MultipleObjectReference', value: 11 },
			{ name: 'CurrencyType', value: 12 },
			{ name: 'ColorType', value: 15 },
			{ name: 'HtmlType', value: 16 },
			{ name: 'IsArray', value: 101 },
		];

		vm.schemaEditorMode = [
			{ name: 'Types', value: 1 },
			{ name: 'Classes', value: 2 },
		];

		vm.bindingTypeItems = [
			{ name: 'One Way', value: EditorBindingType.OneWay },
			{ name: 'Two Way', value: EditorBindingType.TwoWay },
		];
	};

	$scope.$watch('vm.value', function (newValue) {
		if (localChanged) {
			localChanged = false;
		} else {
			vm._value = JSON.parse(newValue) || {};
			if (vm.editor === undefined || vm.editor === -1) {
				vm.editors.some(function (editor) {
					var result = editor.editorTypes.some(function (types) {
						return types.value === vm._value.Type;
					});
					if (result) {
						vm.editor = editor.value;
					}

					return result;
				});
			}
		}
	});

	$scope.$watch(
		'vm._value',
		function (newValue) {
			localChanged = true;
			processValue(newValue);
		},
		true
	);

	$scope.$watch('vm.relatedTag', function (newValue) {
		if (newValue !== undefined) {
			setValue('RelatedTag', vm.tags.getNameByValue(newValue));
		}
	});

	$scope.$watch(
		function (scope) {
			return scope.vm.mode + (scope.vm.isMultiPicker ? 10 : 0) + (scope.vm.bindable ? 50 : 0);
		},
		function () {
			setValue('Mode', vm.mode);
			setValue('IsMultiPicker', vm.isMultiPicker);
			setValue('Bindable', vm.bindable);
		}
	);

	$scope.$watch('vm.entityClassName', function (newValue) {
		setValue('EntityClassName', newValue);
	});

	$scope.$watch('vm.allowedTypes', function (newValue) {
		setValue('AllowedTypes', newValue);
	});

	$scope.$watch('vm.useObjectId', function (newValue) {
		setValue('UseObjectId', newValue);
	});

	$scope.$watch('vm.useMultiSelect', function (newValue) {
		setValue('UseMultiSelect', newValue);
	});

	$scope.$watch('vm.dataDefinitionPropertyName', function (newValue) {
		setValue('DataDefinitionPropertyName', newValue);
	});

	$scope.$watch(
		'vm.supportedTypes',
		function (newValue) {
			stToArray(newValue);
			setValue('SupportedTypes', supportedTypes);
		},
		true
	);

	$scope.$watch('vm.editor', function (newValue, oldValue) {
		if (newValue === undefined || newValue === oldValue) {
			return;
		}

		var sk = vm.editors.getByValue(oldValue).supportedKey;
		if (sk) {
			vm._value[sk] = undefined;
		}
		var editor = vm.editors.getByValue(newValue);
		vm.editorTypes = editor.editorTypes;

		if (
			!editor.editorTypes.some(function (type) {
				return type.value === vm._value.Type;
			})
		) {
			if (newValue === 0 && type) {
				vm._value.Type = type;
			} else {
				vm._value.Type = editor.editorTypes[0].value;
			}
		}
	});

	function stToArray(st) {
		var arr = [];
		_.forIn(st, function (value, key) {
			if (value) {
				if (key === '101') {
					arr.push({ IsArray: true });
				} else {
					arr.push({ Type: key });
				}
			}
		});
		supportedTypes = arr;
	}

	function stFromArray() {
		_.forIn(vm.supportedTypes, function (value, key) {
			if (value) {
				vm.supportedTypes[key] = false;
			}
		});

		supportedTypes.forEach(function (item) {
			if (item.Type === undefined) {
				vm.supportedTypes[101] = true;
			} else {
				vm.supportedTypes[item.Type] = true;
			}
		});
	}

	function strEnumerationFromJson() {
		if (enumeration) {
			var arr = [];
			var obj = JSON.parse(enumeration);
			_.forIn(obj, function (value, key) {
				arr.push(key + ':' + value);
			});
			vm.enumeration = arr.join('\r\n');
		} else {
			vm.enumeration = '';
		}
	}

	function strEnumerationToJson() {
		var reg = /^(?:\s+)?([\w_\-\d.\\:\\ ]+?)(?:\s+)?:(?:\s+)?([\w_\-\d.\\:\\ ]+?)(?:\s+)?$/gim;
		var obj = {};

		var result;
		while ((result = reg.exec(vm.enumeration))) {
			obj[result[1]] = result[2];
		}

		enumeration = JSON.stringify(obj).replace(/[\\/]/gi, '');
		setValue('Enumeration', enumeration);
	}

	function processValue(value) {
		processEditor(value);
		processType(value);
		var obj = angular.copy(value);
		obj.EntityClassName = obj.EntityClassName || undefined;
		obj.Enumeration = obj.Enumeration || undefined;
		obj.RelatedTag = obj.RelatedTag || undefined;
		vm.value = JSON.stringify(obj);
	}

	function processEditor(value) {
		if (vm.editor === 0) {
			type = value.Type;
		}

		if (value.SupportedTypes) {
			supportedTypes = value.SupportedTypes;
			stFromArray();
		}

		if (value.Enumeration) {
			enumeration = value.Enumeration;
			strEnumerationFromJson();
		}

		if (value.Mode) {
			vm.mode = value.Mode;
			vm.bindable = value.Bindable;
			vm.isMultiPicker = value.IsMultiPicker;
		}

		if (value.RelatedTag) {
			vm.relatedTag = vm.tags.getValueByName(value.RelatedTag);
		}

		if (value.EntityClassName) {
			vm.entityClassName = value.EntityClassName;
		}

		if (value.AllowedTypes) {
			vm.allowedTypes = value.AllowedTypes;
		}

		if (value.UseObjectId) {
			vm.useObjectId = value.UseObjectId;
		}

		if (value.UseMultiSelect) {
			vm.useMultiSelect = value.UseMultiSelect;
		}
	}

	function processType(value) {
		switch (value.Type) {
			case PropertyEditorType.String:
			case PropertyEditorType.Text:
			case PropertyEditorType.Boolean:
			case PropertyEditorType.Integer:
			case PropertyEditorType.Image:
			case PropertyEditorType.Unit:
			case PropertyEditorType.ComplexData:
			case PropertyEditorType.Localizable:
				break;
			case PropertyEditorType.StylePicker:
				vm.editor = 4;
				value.RelatedTag = vm.tags.getNameByValue(vm.relatedTag);
				break;
			case PropertyEditorType.Enumeration: //enumeration
				value.Enumeration = enumeration;
				vm.editor = 3;
				break;
			case PropertyEditorType.Bindable: //bindable
				value.SupportedTypes = supportedTypes;
				vm.editor = 1;
				break;
			case PropertyEditorType.Schema: //schema
				vm.editor = 5;
				value.Mode = vm.mode;
				value.IsMultiPicker = vm.isMultiPicker;
				value.Bindable = vm.bindable;
				break;
			case PropertyEditorType.ObjectPicker:
				vm.editor = 6;
				value.EntityClassName = vm.entityClassName;
				value.AllowedTypes = vm.allowedTypes;
				value.UseObjectId = vm.useObjectId;
				value.UseMultiSelect = vm.useMultiSelect;
				break;
			case PropertyEditorType.DescriptorStylesPicker:
				vm.editor = 7;
				break;
			case PropertyEditorType.ExpressionFilter:
				vm.editor = 8;
				vm.dataDefinitionPropertyName = value.DataDefinitionPropertyName;
				break;
		}
	}

	function setValue(key, value) {
		const supportedKeys = vm.editors.getByValue(vm.editor).supportedKey;
		if (!supportedKeys) {
			return;
		}

		let contains = false;
		if (typeof supportedKeys === 'string' && supportedKeys === key) {
			contains = true;
		} else if (Array.isArray(supportedKeys) && supportedKeys.indexOf(key) !== -1) {
			contains = true;
		}

		if (contains) {
			vm._value[key] = value;
		}
	}

	async function loadStyles() {
		if (tags) {
			return tags;
		}

		tags = [];
		const classes = stylesService.loadClasses();

		classes.forEach(function (cls) {
			if (cls.tags && Array.isArray(cls.tags)) {
				tags = tags.concat(cls.tags);
			}
		});

		tags = _.uniq(tags).map(function (tag, i) {
			return {
				value: i,
				name: tag,
			};
		});

		tags.getNameByValue = function (value) {
			return (tags[value] || {}).name;
		};

		tags.getValueByName = function (name) {
			return (_.find(tags, ['name', name]) || {}).value;
		};

		return tags;
	}
}
